import { isBrowser } from '@squareup/util-isomorphic';

var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["Development"] = "development";
  Environment2["Staging"] = "staging";
  Environment2["Sandbox"] = "sandbox";
  Environment2["Test"] = "test";
  Environment2["Production"] = "production";
  return Environment2;
})(Environment || {});
function getServerEnvironment() {
  if (process.env.ENVIRONMENT === "staging") {
    return "staging" /* Staging */;
  }
  if (process.env.ENVIRONMENT === "sandbox") {
    return "sandbox" /* Sandbox */;
  }
  if (process.env.ENVIRONMENT === "production") {
    return "production" /* Production */;
  }
  return "development" /* Development */;
}
function getBrowserEnvironment() {
  const host = window.location.hostname;
  if (window.__ENVIRONMENT__ === "sandbox" /* Sandbox */ && !window.__DASHBOARD_ENABLE_SANDBOX__) {
    return "production" /* Production */;
  }
  if (Object.values(Environment).includes(window.__ENVIRONMENT__)) {
    return window.__ENVIRONMENT__;
  }
  if (import.meta.env.DEV) {
    return "development" /* Development */;
  }
  if (/^(?:app\.)?squareupsandbox\.com$/.test(host)) {
    return window.__DASHBOARD_ENABLE_SANDBOX__ ? "sandbox" /* Sandbox */ : "production" /* Production */;
  }
  if (host.includes("squareupstaging") || host.includes("stage.sqprod.co")) {
    return "staging" /* Staging */;
  }
  if (host.includes("squareup")) {
    return "production" /* Production */;
  }
  return "development" /* Development */;
}
function getEnvironment() {
  if (process.env.NODE_ENV === "test") {
    return "test" /* Test */;
  }
  if (isBrowser()) {
    return getBrowserEnvironment();
  }
  return getServerEnvironment();
}
function isHostedEnvironment() {
  return isProductionEnvironment() || isStagingEnvironment() || isSandboxEnvironment();
}
function isHostedServerEnvironment() {
  if (isBrowser()) {
    return false;
  }
  return isHostedEnvironment();
}
function isProductionEnvironment() {
  return getEnvironment() === "production" /* Production */;
}
function isStagingEnvironment() {
  return getEnvironment() === "staging" /* Staging */;
}
function isSandboxEnvironment() {
  return getEnvironment() === "sandbox" /* Sandbox */;
}
function isPlaypen() {
  return process.env.IS_PLAYPEN === "true";
}
function isPreviewDeployment() {
  return process.env.IS_PR_PREVIEW_DEPLOYMENT === "true";
}
function isDevelopmentEnvironment() {
  return getEnvironment() === "development" /* Development */;
}
function isTestEnvironment() {
  return getEnvironment() === "test" /* Test */;
}
function isHeadlessBrowser() {
  return isBrowser() && /headlesschrome/i.test(window.navigator.userAgent);
}
function isAndroid() {
  return isBrowser() && /android/i.test(window.navigator.userAgent);
}
function isIOS() {
  return isBrowser() && /iPad|iPhone|iPod/.test(window.navigator.userAgent);
}

export { Environment, getEnvironment, isAndroid, isDevelopmentEnvironment, isHeadlessBrowser, isHostedEnvironment, isHostedServerEnvironment, isIOS, isPlaypen, isPreviewDeployment, isProductionEnvironment, isSandboxEnvironment, isStagingEnvironment, isTestEnvironment };
